<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-frais"></i>
    </div>
    <div class="lvi-body">
        <div class="title" (click)="onSelect()">
            <a>{{ data.libelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.prestations.detail.zu.zonesUtilisateur.type.title'"></strong>
                <span [translate]="'admin.frais.prestations.detail.zu.zonesUtilisateur.type.' + data.typeChamp"></span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.detail.zu.zonesUtilisateur.obligatoire'"></strong>
                <span [translate]="'global.' + (data.lienZuPrestObligatoire ? 'oui' : 'non')"></span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteZu()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>